/* eslint-disable jsx-a11y/no-autofocus */
var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React, { memo } from 'react';
import styled from 'styled-components';
import { Button, Flex, Text } from 'pcln-design-system';
import { Minus, Plus } from 'pcln-icons';
var StyledFlex = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "Counter__StyledFlex",
  componentId: "sc-14w9w2p-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  gap: 12px;\n"], ["\n  gap: 12px;\n"])));
var PlusButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "Counter__PlusButton",
  componentId: "sc-14w9w2p-1"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &&& {\n    height: 40px;\n    padding: 0;\n    width: 40px;\n  }\n"], ["\n  &&& {\n    height: 40px;\n    padding: 0;\n    width: 40px;\n  }\n"])));
var MinusButton = /*#__PURE__*/styled(PlusButton).withConfig({
  displayName: "Counter__MinusButton",
  componentId: "sc-14w9w2p-2"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  &&& {\n    visibility: ", ";\n  }\n"], ["\n  &&& {\n    visibility: ", ";\n  }\n"])), function (props) {
  return props.disabled ? 'hidden' : 'visible';
});
var NoSelectText = /*#__PURE__*/styled(Text).withConfig({
  displayName: "Counter__NoSelectText",
  componentId: "sc-14w9w2p-3"
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 30px;\n  text-align: center;\n  user-select: none;\n"], ["\n  width: 30px;\n  text-align: center;\n  user-select: none;\n"])));
/** @public */
var Counter = function (_a) {
  var autoFocus = _a.autoFocus,
    className = _a.className,
    count = _a.count,
    label = _a.label,
    min = _a.min,
    max = _a.max,
    onChange = _a.onChange;
  var spacelessLabel = label && label.replace(' ', '-');
  var minusDisabled = count === min;
  var plusDisabled = count >= max;
  var minusLabel = "Decrease ".concat(label).concat(minusDisabled ? ' - disabled' : '');
  var plusLabel = "Increase ".concat(label).concat(plusDisabled ? ' - disabled' : '');
  var minusColor = minusDisabled ? 'background.tone' : 'error';
  var plusColor = plusDisabled ? 'background.tone' : 'primary';
  function onMinusClick() {
    return !minusDisabled && onChange(--count);
  }
  function onPlusClick() {
    return !plusDisabled && onChange(++count);
  }
  var id = "".concat(spacelessLabel, "-number");
  return React.createElement(StyledFlex, {
    alignItems: 'center',
    className: className
  }, React.createElement(MinusButton, {
    "aria-controls": id,
    "aria-label": minusLabel,
    autoFocus: !minusDisabled && autoFocus,
    disabled: minusDisabled,
    onClick: onMinusClick,
    type: 'button',
    variation: 'subtle'
  }, React.createElement(Minus, {
    title: minusLabel,
    color: minusColor
  })), React.createElement(NoSelectText, {
    id: id,
    "aria-live": 'polite',
    "aria-atomic": 'true',
    fontSize: 2,
    px: 2
  }, count), React.createElement(PlusButton, {
    "aria-controls": id,
    "aria-label": plusLabel,
    autoFocus: minusDisabled && autoFocus,
    disabled: plusDisabled,
    onClick: onPlusClick,
    type: 'button',
    variation: 'subtle'
  }, React.createElement(Plus, {
    title: plusLabel,
    color: plusColor
  })));
};
export default memo(Counter);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;